var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowBack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 7,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#004165",
  d: "M6.633.235a.8.8 0 0 0-1.132 0L.187 5.549a.637.637 0 0 0 0 .902l5.314 5.314a.8.8 0 0 0 1.132 0 .8.8 0 0 0 0-1.132l-4.63-4.636L6.64 1.36A.797.797 0 0 0 6.633.235"
})));
export { SvgArrowBack as ReactComponent };
export default __webpack_public_path__ + "625fde0fcc191420332479794e53030e.svg";